// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_DisponiveisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for planocontas/disponiveis endpoint
 *
 * Returns available plano contas with suggestion and options
 */
import type { Planocontas_DisponivelOpcaoRow } from './Planocontas_DisponivelOpcaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_DisponiveisResponseDados {
sugerido: Planocontas_DisponivelOpcaoRow
opcoes: Planocontas_DisponivelOpcaoRow[]
tem_fechamento: boolean
}

export type Planocontas_DisponiveisResponse = ApiResponse<Planocontas_DisponiveisResponseDados>;

registerResponseContract('Planocontas_DisponiveisResponse', {
  sugerido: {
    type: 'object',
    required: false,
    fields: {
      id:              { type: 'number',  required: false },
      nome_conta:      { type: 'string',  required: false },
      valor_previsto:  { type: 'number',  required: false },
      periodo:         { type: 'string',  required: false },
      categoria_match: { type: 'boolean', required: false },
    },
  },
  opcoes: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: false },
      nome_conta:      { type: 'string',  required: false },
      valor_previsto:  { type: 'number',  required: false },
      periodo:         { type: 'string',  required: false },
      categoria_match: { type: 'boolean', required: false },
    },
  },
  tem_fechamento: { type: 'boolean', required: true },
})
